import http from '@/api/common'

export default {
  getFiles(path) {
    return http.get(`file/list?folder=${path}`)
  },
  getBase64File(file) {
    return http.get(`file/fileBase64?file=${file}`)
  },
  getThumbs(path) {
    return http.get(`file/thumbsBase64?path=${path}`)
  },
  uploadBase64File(data) {
    return http.post('file/uploadBase64', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/files.js